export default class CompanyManagingDirector {
    name: string;
    constructor(companyManagingDirector) {
        this.name = companyManagingDirector.name === undefined ? null : companyManagingDirector.name;
    }
}